import { render, staticRenderFns } from "./NominationRadioRow.vue?vue&type=template&id=31a37692&scoped=true&"
import script from "./NominationRadioRow.vue?vue&type=script&lang=js&"
export * from "./NominationRadioRow.vue?vue&type=script&lang=js&"
import style0 from "./NominationRadioRow.vue?vue&type=style&index=0&id=31a37692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a37692",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
